import * as Styled from './styled'

export type PaymentType = 'promptpay' | 'credit'

export interface CreditMember {
  balance: number
  name?: string
  phone?: string
}

interface PaymentMethodPickerProps {
  value: PaymentType
  onChange: (v: PaymentType) => void
  totalPrice: number
  creditMember: CreditMember | null | undefined
  liffLinkUrl?: string
}

const DEFAULT_LIFF_LINK = 'https://credit.remedy.coffee/liff/link'

const PaymentMethodPicker = ({
  value,
  onChange,
  totalPrice,
  creditMember,
  liffLinkUrl = DEFAULT_LIFF_LINK,
}: PaymentMethodPickerProps): JSX.Element => {
  const balance = creditMember?.balance ?? 0
  const isMember = creditMember != null
  const hasEnough = isMember && balance >= totalPrice
  const deficit = Math.max(0, totalPrice - balance)
  const creditDisabled = !hasEnough

  const onCreditClick = () => {
    if (!creditDisabled) onChange('credit')
  }

  const renderCreditDetail = () => {
    if (!isMember) {
      return (
        <Styled.OptionDetail>
          <p>ยังไม่ได้เป็นสมาชิก Wallet</p>
          <Styled.NudgeButton
            href={liffLinkUrl}
            target='_blank'
            rel='noopener noreferrer'
          >
            สมัครสมาชิก →
          </Styled.NudgeButton>
        </Styled.OptionDetail>
      )
    }

    if (!hasEnough) {
      const topupUrl = `${liffLinkUrl}?action=topup&suggested=${deficit}`
      return (
        <Styled.OptionDetail>
          <Styled.BalanceRow>
            <span>ยอดของคุณ</span>
            <span>฿{balance.toLocaleString()}</span>
          </Styled.BalanceRow>
          <Styled.BalanceRow>
            <span>ขาดอีก</span>
            <Styled.Warn>฿{deficit.toLocaleString()} ⚠️</Styled.Warn>
          </Styled.BalanceRow>
          <Styled.NudgeButton
            href={topupUrl}
            target='_blank'
            rel='noopener noreferrer'
          >
            เติม Wallet ฿{deficit.toLocaleString()} →
          </Styled.NudgeButton>
        </Styled.OptionDetail>
      )
    }

    const balanceAfter = balance - totalPrice
    return (
      <Styled.OptionDetail>
        <Styled.BalanceRow>
          <span>ยอดของคุณ</span>
          <span>฿{balance.toLocaleString()}</span>
        </Styled.BalanceRow>
        <Styled.BalanceRow>
          <span>หลังหัก</span>
          <span>฿{balanceAfter.toLocaleString()}</span>
        </Styled.BalanceRow>
      </Styled.OptionDetail>
    )
  }

  return (
    <Styled.Wrapper>
      <Styled.SectionTitle>วิธีชำระเงิน</Styled.SectionTitle>
      <Styled.OptionList>
        <Styled.Option
          selected={value === 'credit'}
          disabled={creditDisabled}
          onClick={onCreditClick}
        >
          <Styled.OptionHeader>
            <input
              type='radio'
              name='paymentMethod'
              checked={value === 'credit'}
              disabled={creditDisabled}
              onChange={onCreditClick}
            />
            ใช้ Remedy Wallet
          </Styled.OptionHeader>
          {renderCreditDetail()}
        </Styled.Option>

        <Styled.Option
          selected={value === 'promptpay'}
          disabled={false}
          onClick={() => onChange('promptpay')}
        >
          <Styled.OptionHeader>
            <input
              type='radio'
              name='paymentMethod'
              checked={value === 'promptpay'}
              onChange={() => onChange('promptpay')}
            />
            PromptPay QR
          </Styled.OptionHeader>
          <Styled.OptionDetail>
            <p>สแกนจ่ายผ่านแอปธนาคารหลังกด Place Order</p>
          </Styled.OptionDetail>
        </Styled.Option>
      </Styled.OptionList>
    </Styled.Wrapper>
  )
}

export default PaymentMethodPicker
